import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './classes.module.scss';

const Subtitle = ({ name, className }) => (
  <div className={ className || classes.subtitle }>
    { name }
  </div>
);

Subtitle.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default Subtitle;
